<template>
    <!-- MY1-3082: the conversion path into auto-tracking — a connectable card
         that isn't connected yet. Same banner as the wallet's card details
         (MY1-3044), same per-institution dismissal, same connect flow. -->
    <div
        v-if="visible"
        class="mb-6 rounded-lg border border-orange-200 dark:border-orange-400/30 bg-gradient-to-br from-orange-50 to-amber-50 dark:from-orange-500/15 dark:to-amber-500/10 p-4 flex flex-col gap-3"
        data-test="connect-bank-banner"
    >
        <div class="flex items-start gap-2">
            <Icon
                icon="bank-financial"
                class="w-5 h-5 shrink-0 text-orange-500"
            />
            <div class="flex flex-col gap-0.5 min-w-0">
                <p
                    class="text-sm font-medium leading-5 text-slate-800 dark:text-slate-100"
                >
                    Connect bank to auto-track benefits
                </p>
                <p
                    class="text-sm font-normal leading-5 text-slate-600 dark:text-slate-300"
                >
                    Add a bank connection to automatically track your spending,
                    benefits, and welcome bonuses.
                </p>
            </div>
        </div>
        <div class="flex items-center gap-4">
            <button
                type="button"
                class="btn btn-orange !w-auto px-4 py-2 text-sm font-medium"
                data-test="connect-bank"
                @click="connect"
            >
                Connect bank
            </button>
            <button
                type="button"
                class="text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-slate-800 dark:hover:text-slate-100 transition-colors"
                data-test="dismiss-banner"
                @click="dismiss"
            >
                Dismiss
            </button>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { router, usePage } from '@inertiajs/vue3';
import Icon from '@/components/ui/icon/icon.vue';
import { useWalletStore } from '@/store/wallet';
import { useCardBenefitsStore } from '@/store/card-benefits';

const props = defineProps({
    // The benefit payload's `auto_tracking` object.
    autoTracking: {
        type: Object,
        default: null,
    },
});

const emit = defineEmits(['connect', 'dismiss']);

const store = useCardBenefitsStore();

const institutionCode = computed(
    () => props.autoTracking?.institution_code || null
);

const visible = computed(() => {
    if (props.autoTracking?.state !== 'available' || !institutionCode.value) {
        return false;
    }

    if (store.dismissedConnectInstitutions.includes(institutionCode.value)) {
        return false;
    }

    const persisted =
        usePage().props.userData?.dismissed_connect_institutions || {};

    return !(institutionCode.value in persisted);
});

function connect() {
    emit('connect');
    // The wallet page owns the MX connect modal (MY1-3044) and opens it when
    // the store flag is raised — no parallel entry point here.
    useWalletStore().requestConnectModal();
    router.visit('/wallet');
}

function dismiss() {
    emit('dismiss');
    store.dismissConnectInstitution(institutionCode.value);
}
</script>
